<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.issueDateRules"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="damageHeader.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No."
                  v-model="damageHeader.invoiceNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex :class="damageHeader.id ? 'sm6' : 'sm12'">
                <v-text-field
                  name="creditNoteNo"
                  label="Credit Note No."
                  v-model="damageHeader.creditNoteNo"
                  type="text"
                  :rules="rules.creditNoteNoRules(255, 'Credit Note No')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="damageHeader.shopId"
                  :items="shopList"
                  color="blue-grey lighten-2"
                  label="Choose Shop..."
                  item-text="name"
                  @change="
                    changeProductParam(),
                      changeCustomer(),
                      clearCustomerAndInvoice(),
                      getWarehouseByShop()
                  "
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.shopRules"
                  :readonly="
                    user.role.roleName == 'SALE_MANAGER' ||
                    user.role.roleName == 'GENERAL_MANAGER' ||
                    user.role.roleName == 'BRANCH_ADMIN' ||
                    status != 'DRAFT'
                      ? true
                      : false
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="damageHeader.invoiceType"
                  :items="invoiceTypeList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Invoice Type..."
                  item-text="label"
                  item-value="name"
                  menu-props="auto"
                  @change="changeInvoiceType()"
                  :rules="rules.invoiceTypeRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  placeholder="Choose Customer..."
                  v-model="damageHeader.customerName"
                  @click="showCustomers()"
                  :disabled="damageHeader.shopId ? false : true"
                  :rules="rules.customerIdRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  placeholder="Choose Invoice..."
                  v-model="damageHeader.creditInvoiceId"
                  @click="showCreditInvoices()"
                  :clearable="true"
                  @click:clear="clearInvoice()"
                  :disabled="
                    damageHeader.shopId &&
                    damageHeader.customerName &&
                    damageHeader.invoiceType
                      ? false
                      : true
                  "
                ></v-text-field>
                <span
                  class="caption , ml-2 , info--text"
                  v-if="!(damageHeader.shopId && damageHeader.customerName)"
                  >Choose Shop, Customer and Invoice Type First</span
                >
              </v-flex>
              <v-flex sm12 v-if="damageHeader.id">
                <v-autocomplete
                  v-model="damageHeader.damageStatus"
                  :items="damageStatusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="name"
                  menu-props="auto"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="taxAmount"
                  label="Tax Amount"
                  v-model="damageHeader.taxAmount"
                  type="number"
                  @input="calculate()"
                  :rules="rules.taxAmountRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="discountAmount"
                  label="Discount Amount"
                  v-model="damageHeader.discountAmount"
                  type="number"
                  @input="calculate()"
                  :rules="rules.discountAmountRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="promotionAmount"
                  label="Promotion Amount"
                  v-model="damageHeader.promotionAmount"
                  type="number"
                  @input="calculate()"
                  :rules="rules.promotionAmountRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="expenseAmount"
                  label="Expense Amount"
                  v-model="damageHeader.expenseAmount"
                  type="number"
                  @input="calculate()"
                  :rules="rules.damageExpenseAmountRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm8>
                <v-text-field
                  v-model="damageHeader.remark"
                  name="remark"
                  label="Remark"
                  type="text"
                  :rules="rules.remarkRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm4>
                <v-card mt-4 style="card-border: 1px solid #dde6f3">
                  <v-card-text class="font-weight-bold">
                    <span>Total Amount</span>
                    <span class="ml-5"
                      >:
                      {{
                        damageHeader.totalAmount | decFormat(6)
                      }}</span
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex sm6 v-if="damageHeader.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="damageHeader.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="damageHeader.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="damageHeader.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="damageHeader.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="damageHeader.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-flex sm2>
                    <v-btn
                      color="success"
                      @click="addItem()"
                      :disabled="
                        status != 'DRAFT' || addItemBtnDisabled || typeDisabled
                          ? true
                          : false
                      "
                    >
                      Add Item
                      <v-icon right>add</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex sm2>
                    <v-switch
                      v-model="isItemDiscount"
                      inset
                      :label="'Discount'"
                      @change="toggleDiscount"
                      :readonly="isDiscount || typeDisabled ? true : false"
                    ></v-switch>
                  </v-flex>
                  <v-flex sm2>
                    <v-switch
                      v-model="backInStock"
                      inset
                      :label="'Back In Stock'"
                      @change="toggleBackInStock()"
                      :disabled="status != 'DRAFT' ? true : false"
                    ></v-switch>
                  </v-flex>
                  <v-flex sm3 v-if="backInStock">
                    <v-select
                      label="Choose Warehouse..."
                      :items="warehouseList"
                      v-model="damageHeader.backInStockWarehouseId"
                      item-text="name"
                      item-value="id"
                      menu-props="auto"
                      color="blue-grey lighten-2"
                      :hide-no-data="true"
                      @change="getBinsByWarehouse()"
                      readonly
                      :rules="rules.warehouseRules"
                    ></v-select>
                  </v-flex>
                  <v-flex sm3 v-if="backInStock">
                    <v-select
                      label="Choose Bin..."
                      :items="binList"
                      v-model="damageHeader.backInStockBinId"
                      item-text="name"
                      item-value="id"
                      menu-props="auto"
                      color="blue-grey lighten-2"
                      :hide-no-data="true"
                      :rules="rules.binRules"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-flex sm12 v-if="damageAmtErr">
                  <span class="red--text">{{ damageAmtErr }}</span>
                </v-flex>
                <v-layout row class="light--text">
                  <v-flex xs2>Code</v-flex>
                  <v-flex xs3>Name</v-flex>
                  <v-flex xs2>Unit</v-flex>
                  <v-flex xs1>Qty</v-flex>
                  <v-flex xs2 v-if="user.role.roleName != 'WAREHOUSE_MANAGER'"
                    >Selling Price</v-flex
                  >
                  <v-flex xs1 v-if="isItemDiscount">Discount</v-flex>
                  <v-flex xs2 v-if="user.role.roleName != 'WAREHOUSE_MANAGER'"
                    >Amount</v-flex
                  >
                  <v-flex xs3>QC No</v-flex>
                  <v-flex xs2>Batch No</v-flex>
                  <v-flex xs3 class="text-xs-center">MFG Date</v-flex>
                  <v-flex xs3 class="text-xs-center">EXP Date</v-flex>
                  <v-flex xs2>Remark</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  v-for="(damageDetail, index) in damageHeader.damageDetailList"
                  :key="index"
                >
                  <v-flex xs2>
                    <v-text-field
                      v-if="status != 'DRAFT' || typeDisabled ? true : false"
                      placeholder="Select the code"
                      v-model="damageDetail.productCode"
                      readonly
                      :rules="rules.codeRules"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      placeholder="Select the code"
                      v-model="damageDetail.productCode"
                      :disabled="
                        damageHeader.shopId && damageHeader.customerId
                          ? false
                          : true
                      "
                      @click="showProducts(), (selectedIndex = index)"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="damageDetail.productName"
                      :loading="showAutocompleteLoading"
                      label="Product"
                      :readonly="true"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="damageDetail.factorUnitName"
                      :loading="showAutocompleteLoading"
                      :hide-no-data="true"
                      :items="damageDetail.productUnits"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      label="Select"
                      :readonly="
                        status != 'DRAFT' || typeDisabled ? true : false
                      "
                      @change="(option) => initPrice(option, index)"
                      :rules="rules.unitRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="damageDetail.qty"
                      min="0"
                      onchange="this.value = Math.abs(this.value)"
                      :rules="rules.qtyRules"
                      :readonly="status != 'DRAFT' ? true : false"
                      @input="calculate()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 v-if="user.role.roleName != 'WAREHOUSE_MANAGER'">
                    <v-text-field
                      v-model="damageDetail.price"
                      type="number"
                      min="0"
                      :readonly="status != 'DRAFT' ? true : false"
                      :rules="rules.sellingPriceRules"
                      @input="calculate()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs1
                    v-if="isItemDiscount"
                  >
                    <v-text-field
                      v-model="damageDetail.discountPercent"
                      onchange="this.value = Math.abs(this.value)"
                      type="number"
                      min="0"
                      max="100"
                      :readonly="status != 'DRAFT' ? true : false"
                      :rules="rules.discountPercentRules"
                      @input="calculate()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs2
                    pt-4
                    v-if="user.role.roleName != 'WAREHOUSE_MANAGER'"
                  >
                    <span
                      v-if="isItemDiscount && damageDetail.productUnitDTO"
                      >{{
                        (damageDetail.qty *
                          (damageDetail.price -
                            damageDetail.price *
                              (damageDetail.discountPercent / 100)))
                          | decFormat(6)
                      }}</span
                    >
                    <span v-else>{{
                      (damageDetail.price * damageDetail.qty)
                        | decFormat(6)
                    }}</span>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-if="status != 'DRAFT' || typeDisabled"
                      placeholder="QC No"
                      v-model="damageDetail.qcNo"
                      append-icon="search"
                      readonly
                    ></v-text-field>
                    <v-text-field
                      v-else
                      name="qcNo"
                      placeholder="QC No"
                      v-model="damageDetail.qcNo"
                      color="warning"
                      clearable
                      append-icon="search"
                      @click:clear="clearQCno(damageDetail)"
                      @click:append="openQCListDialog(damageDetail, index)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      name="batchNo"
                      placeholder="Batch No"
                      v-model="damageDetail.batchNo"
                      :readonly="status != 'DRAFT' || typeDisabled"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="status != 'DRAFT' || typeDisabled"
                    >
                      <v-text-field
                        slot="activator"
                        placeholder="MFG Date"
                        type="text"
                        prepend-icon="event"
                        v-model="damageDetail.mfgDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="damageDetail.mfgDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="status != 'DRAFT' || typeDisabled"
                    >
                      <v-text-field
                        slot="activator"
                        placeholder="EXP Date"
                        type="text"
                        prepend-icon="event"
                        v-model="damageDetail.expDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="damageDetail.expDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="damageDetail.remark"
                      type="text"
                      :readonly="status != 'DRAFT' ? true : false"
                      :rules="rules.remarkRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      class="mx-0"
                      icon
                      @click="removeDamageDetail(index, damageDetail.id)"
                      :disabled="status != 'DRAFT' ? true : false"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="status != 'DRAFT' ? true : false"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    @click="onSave"
                    :disabled="
                      status != 'DRAFT' || damageAmtErr || saveLoading
                        ? true
                        : false
                    "
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Invoice list dialog -->
    <v-dialog v-model="showInvoiceListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="invoiceQueryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="invoiceQueryParams.fromDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="invoiceQueryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="invoiceQueryParams.toDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="saleTypeList"
                label="Sale Type"
                item-text="label"
                item-value="value"
                v-model="invoiceQueryParams.saleType"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="invoiceNo"
                label="Invoice No"
                type="text"
                class="mr-1"
                v-model="invoiceQueryParams.invoiceNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchInvoice">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-card>
            <v-card-title class="blue darken-3">
              <span class="headline white--text">Summary</span>
            </v-card-title>
            <v-card-text class="font-weight-bold">
              <div>
                <span>Total Net Amount:</span>
                <v-chip>
                  <span>{{ totalNetAmount | numFormat }}</span>
                </v-chip>
              </div>
              <!-- <div>
                <span>Total Paid Amount:</span>
                <v-chip>
                  <span>{{ totalCreditPaidAmount | numFormat}}</span>
                </v-chip>
              </div>-->
              <div>
                <span>Total Remaining Amount:</span>
                <v-chip>
                  <span>{{ totalRemainingAmount | numFormat }}</span>
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
          <!-- Invoice List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="invoiceListHeaders"
                :items="creditInvoiceList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="invoiceTotalRows"
                :rows-per-page-items="rowsPerPageItems3"
                :pagination.sync="invoicePagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setInvoice(props.item),
                        (showInvoiceListDialog = !showInvoiceListDialog)
                    "
                  >
                    <a>{{ props.item.invoiceNo }}</a>
                  </td>
                  <td>
                    {{
                      props.item.createdDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.netAmount | numFormat }}</td>
                  <td>{{ props.item.creditPaidAmount | numFormat }}</td>
                  <td>{{ props.item.remainingAmount | numFormat }}</td>
                  <td>{{ props.item.saleType }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Customer list dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="Township"
                label="Township"
                type="text"
                class="mr-1"
                v-model="queryParams.township"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-select
                :items="creditLevelList"
                v-model="queryParams.creditLevelId"
                label="Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="activeCustomerList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setCustomer(
                        props.item.name,
                        props.item.id,
                        props.item.priceModelId
                      ),
                        (showCustomerListDialog = !showCustomerListDialog)
                    "
                  >
                    <a>{{ props.item.name }}</a>
                  </td>
                  <td>{{ props.item.code }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.phoneNo }}</td>
                  <td>{{ props.item.address }}</td>
                  <td>{{ props.item.creditLevel.name }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="productQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="productQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="productQueryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="productQueryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="productQueryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchProduct">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="productListHeaders"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems2"
                :pagination.sync="productPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setProduct(props.item.code, selectedIndex),
                        (showProductListDialog = !showProductListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- error message dialog -->
    <v-dialog
      v-model="errorMessageBox"
      max-width="500px"
      @keydown.enter="closeErrMsgBox"
      @keydown.esc="closeErrMsgBox"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeErrMsgBox"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end error message dialog -->
    <QCListDialog
      :showDialog="showQCListDialog"
      :params="{
        warehouseId: damageHeader.backInStockWarehouseId,
        productId: selectedProductId,
        status: 'PASS',
      }"
      @close="closeQCListDialog"
    ></QCListDialog>
  </v-container>
</template>
<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { shopService } from "../../services/shop-service";
import { DamageFormRules } from "../../helpers/validation-rules";
import { creditLevelService } from "../../services/credit-level-service";
import { customerService } from "../../services/customer-service";
import { DamageHeader, DamageDetail } from "../../models/model";
import { damageService } from "../../services/damage-service";
import { commonService } from "../../services/common-service";
import { productService } from "../../services/product-service";
import { customerCreditBalanceService } from "../../services/customer-credit-balance-service";
import { warehouseService } from "../../services/warehouse-service";
import QCListDialog from "../qc/QCListDialog.vue";

export default {
  name: "DamageDetail",
  components: { VSwitch, QCListDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Damage",
        disabled: false,
        to: "damages",
      },
      {
        text: "Damage Detail",
        disabled: true,
      },
    ],
    damageStatusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    invoiceTypeList: [
      // { label: "DAMAGE", value: "DAMAGE" },
      // { label: "DEBIT", value: "DEBIT" },
      // { label: "CREDIT", value: "CREDIT" },
      { label: "SALE_RETURN", value: "SALE_RETURN" },
    ],
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      township: "",
      creditLevelId: "",
      isNoRegion: false,
      regionId: "",
    },
    productQueryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      pricemodelId: "",
      regionId: "",
    },
    invoiceQueryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      saleType: "",
      customerName: "",
      shopId: "",
      invoiceType: "",
      invoiceNo: "",
    },

    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Code", align: "left", value: "code" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Address", value: "address" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    productListHeaders: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    invoiceListHeaders: [
      { text: "Invoice No", value: "invoiceNo", sortable: false },
      { text: "Created Date", value: "createdDate", sortable: false },
      { text: "Net Amount", value: "netAmount", sortable: false },
      { text: "Paid Amount", value: "creditPaidAmount", sortable: false },
      { text: "Remaining Amount", value: "remainingAmount", sortable: false },
      { text: "Sale Type", value: "saleType", sortable: false },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    productPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    invoicePagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    },
    rowsPerPageItems: [10, 50, 100],
    rowsPerPageItems2: [10, 50, 100],
    rowsPerPageItems3: [10, 50, 100],
    customerName: "",
    responseError: "",
    damageAmtErr: "",
    decimalFormat: "",
    showCustomerListDialog: false,
    showInvoiceListDialog: false,
    showListLoading: false,
    showAutocompleteLoading: false,
    saveLoading: false,
    isItemDiscount: false,
    backInStock: false,
    showProductListDialog: false,
    addItemBtnDisabled: false,
    isDiscount: false,
    status: "DRAFT",
    totalRows: 0,
    invoiceTotalRows: 0,
    rules: new DamageFormRules(),
    damageHeader: new DamageHeader(),
    olddamageHeader: new DamageHeader(),
    damageDetail: new DamageDetail(),
    oldDamageDetail: new DamageDetail(),
    shopList: [],
    activeCustomerList: [],
    creditLevelList: [],
    productList: [],
    creditInvoiceList: [],
    creditRemainingAmount: 0,
    saleTypeList: [
      { label: "----All----", value: "" },
      { label: "RETAIL", value: "RETAIL" },
      { label: "SALE", value: "WHOLE_SALE" },
    ],
    totalNetAmount: 0,
    totalCreditPaidAmount: 0,
    totalRemainingAmount: 0,
    typeDisabled: false,
    firstTimeEdit: false,
    warehouseList: [],
    binList: [],
    errorMessageBox: false,
    issueDate: "",
    showQCListDialog: false,
    selectedIndex: 0,
    selectedProductId: "",
  }),

  created() {
    this.decimalFormat = commonService.formatdecimal();
    this.getActiveWarehouse();
    this.getAllShop().then(() => {
      if (
        this.user.role.roleName == "SALE_MANAGER" ||
        this.user.role.roleName == "GENERAL_MANAGER" ||
        this.user.role.roleName == "BRANCH_ADMIN"
      ) {
        this.damageHeader.shopId = this.user.shopId;
        this.getWarehouseByShop();
        this.getActiveWarehouse().then(() => {
          this.getBinsByWarehouse();
        });
        this.changeProductParam();
        this.changeCustomer();
        
      }
      if (
        this.user.role.roleName == "SALE_MANAGER" ||
        this.user.role.roleName == "SALE"
      ) {
        this.damageHeader.saleTeamId = this.user.saleTeamId;
      }
      /*if(this.user.role.roleName == "BRANCH_ADMIN"){
        this.damageHeader.backInStockWarehouseId = this.user.warehouseId;
         this.getActiveWarehouse().then(() => {
              this.getBinsByWarehouse();
            });
      }*/


      const id = this.$route.params.id;
      if (id == "new") {
        this.issueDate = commonService.formatDate(
          new Date().toISOString().substr(0, 10),
          "YYYY-MM-DD"
        );
        this.addItem();
      } else {
        this.isDiscount = true;
        this.getDamageDetail(id);
      }
    });
  },

  watch: {
    pagination: {
      handler() {
        this.getActiveCustomer();
      },
      deep: true,
    },
    productPagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
    invoicePagination: {
      handler() {
        this.getCreditInvoiceList();
        this.getCreditInvoiceSummary();
      },
      deep: true,
    },
    // damageHeader: {
    //   handler() {
    //     this.calculateAmount();
    //   },
    //   deep: true,
    // },
  },

  methods: {
    onSearchProduct() {
      this.productQueryParams.page = this.productPagination.page;
      this.productQueryParams.size = this.productPagination.rowsPerPage;
      this.getProductList();
    },
    getAllShop() {
      return shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    changeCustomer() {
      if (this.damageHeader.shopId) {
        let shop = commonService.search(
          "id",
          this.damageHeader.shopId,
          this.shopList
        );
        if (shop.regionId) {
          this.queryParams.regionId = shop.regionId;
          this.queryParams.isNoRegion = false;
        } else {
          this.queryParams.regionId = "";
          this.queryParams.isNoRegion = true;
        }
        this.getActiveCustomer();
      }
    },
    clearCustomerAndInvoice() {
      if (this.damageHeader.shopId) {
        //clear customer
        this.damageHeader.customerName = "";
        this.damageHeader.customerId = "";
        //clear invoice
        this.damageHeader.creditInvoiceId = "";
        this.damageHeader.creditInvoiceType = "NO_INVOICE";
        this.typeDisabled = false;
      }
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getActiveCustomer();
    },
    showCustomers() {
      this.getCreditLevels();
      // Clean query parmas
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.township = "";
      this.queryParams.status = "ACTIVE";
      this.queryParams.creditLevelId = "";
      this.getActiveCustomer().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );

      //clear invoice
      this.damageHeader.creditInvoiceId = "";
      this.damageHeader.creditInvoiceType = "NO_INVOICE";
      this.typeDisabled = false;
    },
    setCustomer(name, id, pricemodelId) {
      this.damageHeader.customerId = id;
      this.damageHeader.customerName = name;
      this.changeProductParam(pricemodelId);
    },

    changeProductParam(pricemodelId) {
      this.clearDamageDetail();
      this.addItem();
      if (this.damageHeader.shopId) {
        let shop = commonService.search(
          "id",
          this.damageHeader.shopId,
          this.shopList
        );
        this.productQueryParams.regionId = shop.regionId;
      }
      this.productQueryParams.pricemodelId = pricemodelId;
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveCustomer() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.activeCustomerList = res.data.customerList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.productPagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.productQueryParams,
          this.productPagination.page,
          this.productPagination.rowsPerPage,
          this.productPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    addItem() {
      // deep copy
      damageDetail = new DamageDetail();
      let damageDetail = JSON.parse(JSON.stringify(this.damageDetail));
      this.damageHeader.damageDetailList.push(damageDetail);
    },
    removeDamageDetail(index, damageDetailId) {
      if (damageDetailId) {
        // add delete stock in id
        if (!this.damageHeader.deleteDamageDetailIds) {
          this.damageHeader.deleteDamageDetailIds = [];
        }
        this.damageHeader.deleteDamageDetailIds.push(damageDetailId);
      }
      this.$delete(this.damageHeader.damageDetailList, index);
      this.calculate();
    },
    getDamageDetail(id) {
      damageService
        .getDamageDetail(id)
        .then((res) => {
          this.damageHeader = res.data;
          this.damageHeader.customerName = res.data.customerDTO.name;
          this.isItemDiscount = this.damageHeader.isItemDiscount;
          this.backInStock = this.damageHeader.backInStock;
          this.creditRemainingAmount = this.damageHeader.creditRemainingAmount;
          this.issueDate = commonService.millisecondToDate(
            this.damageHeader.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.createdDate = commonService.formatDate(
            new Date(this.damageHeader.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.damageHeader.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.damageHeader.damageDetailList.forEach((damageDetail) => {
            if (damageDetail.mfgDateInMilliSeconds) {
              damageDetail.mfgDate = commonService.millisecondToDate(
                damageDetail.mfgDateInMilliSeconds,
                "YYYY-MM-DD"
              );
            }
            if (damageDetail.expDateInMilliSeconds) {
              damageDetail.expDate = commonService.millisecondToDate(
                damageDetail.expDateInMilliSeconds,
                "YYYY-MM-DD"
              );
            }
          });
          this.status = this.damageHeader.damageStatus;
          if (this.damageHeader.invoiceType == "SALE_RETURN") {
            this.typeDisabled = true;
          }
          /*if (this.user.role.roleName == "WAREHOUSE_MANAGER") {
            if (this.damageHeader.backInStock) {
              if (
                this.user.warehouseId !=
                this.damageHeader.backInStockWarehouseId
              ) {
                this.damageHeader.backInStockBinId = "";
              }
            }
            this.damageHeader.backInStockWarehouseId = this.user.warehouseId;
          }*/
          if (this.damageHeader.backInStockWarehouseId) {
            this.getActiveWarehouse().then(() => {
              this.getBinsByWarehouse();
            });
          } else {
            this.getWarehouseByShop();
          }
          this.issueDate = commonService.millisecondToDate(
            this.damageHeader.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          if (this.damageHeader.customerDTO.priceModelId) {
            this.productQueryParams.pricemodelId =
              this.damageHeader.customerDTO.priceModelId;
          }
          if (this.damageHeader.shopId) {
            let shop = commonService.search(
              "id",
              this.damageHeader.shopId,
              this.shopList
            );
            this.productQueryParams.regionId = shop.regionId;
          }

          this.changeCustomer();
          this.customerName = this.damageHeader.customerDTO.name;
          // deep copy
          this.oldDamageHeader = JSON.parse(JSON.stringify(res.data));
          this.oldDamageDetail = JSON.parse(
            JSON.stringify(res.data.damageDetailList)
          );
          this.firstTimeEdit = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.damageHeader.id) {
        this.damageHeader = new DamageHeader();
        this.customerName = "";
        this.addItem();
      } else {
        this.damageHeader = Object.assign({}, this.oldDamageHeader);
        this.isItemDiscount = this.damageHeader.isItemDiscount;
        this.backInStock = this.damageHeader.backInStock;
      }
    },
    toggleDiscount() {
      if (this.isItemDiscount) {
        this.damageHeader.isItemDiscount = true;
      } else {
        this.damageHeader.isItemDiscount = false;
      }
      this.calculate();
    },
    toggleBackInStock() {
      if (this.backInStock) {
        this.damageHeader.backInStock = true;
      } else {
        this.damageHeader.backInStock = false;
      }
    },
    initPrice(factorUnitName, index) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.damageHeader.damageDetailList[index].productUnits
      );

      this.damageHeader.damageDetailList[index].price =
        productUnit.sellingPrice.toFixed(6);

      this.damageHeader.damageDetailList[index].discountPercent =
        productUnit.sellingPricePercentage;
      this.damageHeader.damageDetailList[index].productUnitDTO = productUnit;
      this.calculate();
    },
    showProducts() {
      // Clean query params
      this.productQueryParams.productCode = "";
      this.productQueryParams.productName = "";
      this.productQueryParams.brandName = "";
      this.productQueryParams.categoryName = "";
      this.productQueryParams.productGroupName = "";
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.damageHeader.damageDetailList[index].productId = product.id;
      this.damageHeader.damageDetailList[index].productCode = product.code;
      this.damageHeader.damageDetailList[index].productName = product.name;
      this.damageHeader.damageDetailList[index].productUnits =
        product.productUnits;
      // set default unit
      var j = "";
      for (var i = 0; i < product.productUnits.length; i++) {
        if (product.productUnits[i].basicUnit == true) j = i;
      }
      this.damageHeader.damageDetailList[index].factorUnitName =
        product.productUnits[j].factorUnitName;
      this.damageHeader.damageDetailList[index].price =
        product.productUnits[j].sellingPrice.toFixed(6);
      this.damageHeader.damageDetailList[index].discountPercent =
        product.productUnits[j].sellingPricePercentage;
      this.damageHeader.damageDetailList[index].productUnitDTO =
        product.productUnits[j];
      this.damageHeader.damageDetailList[index].qty = 0;
      this.clearQCno(this.damageHeader.damageDetailList[index]);
    },
    onSearchInvoice() {
      this.invoiceQueryParams.page = this.invoicePagination.page;
      this.invoiceQueryParams.size = this.invoicePagination.rowsPerPage;
      this.getCreditInvoiceList();
      this.getCreditInvoiceSummary();
    },
    showCreditInvoices() {
      // Clear search query params
      this.invoiceQueryParams.fromDate = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.invoiceQueryParams.toDate = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.invoiceQueryParams.invoiceType = this.damageHeader.invoiceType;
      this.invoiceQueryParams.saleType = "";
      this.invoiceQueryParams.invoiceNo = "";
      this.invoiceQueryParams.shopId = this.damageHeader.shopId;
      this.invoiceQueryParams.customerName = this.damageHeader.customerName;
      this.getCreditInvoiceSummary();
      this.getCreditInvoiceList().then(
        (this.showInvoiceListDialog = !this.showInvoiceListDialog)
      );
    },
    getCreditInvoiceList() {
      this.showListLoading = true;
      return customerCreditBalanceService
        .getCustomerDamageInvoice(
          this.invoiceQueryParams,
          this.invoicePagination.page,
          this.invoicePagination.rowsPerPage
        )
        .then((res) => {
          if (res.data) {
            this.creditInvoiceList = res.data.customerCreditBalanceList;
            this.invoiceTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getCreditInvoiceSummary() {
      customerCreditBalanceService
        .getCustomerDamageInvoiceSummary(this.invoiceQueryParams)
        .then((res) => {
          if (res.data) {
            this.totalNetAmount = res.data.totalNetAmount;
            this.totalCreditPaidAmount = res.data.totalCreditPaidAmount;
            this.totalRemainingAmount = res.data.totalRemainingAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearInvoice() {
      this.typeDisabled = false;
      this.damageHeader.creditInvoiceId = "";
      this.damageHeader.creditInvoiceType = "NO_INVOICE";
    },
    setInvoice(invoice) {
      this.damageHeader.taxAmount = invoice.taxAmount;
      this.damageHeader.discountAmount = invoice.discountAmount;
      this.damageHeader.promotionAmount = invoice.promotionAmount;
      this.damageHeader.expenseAmount = invoice.expenseAmount;
      this.damageHeader.creditInvoiceId = invoice.invoiceNo;
      this.damageHeader.creditInvoiceType = invoice.saleType;
      this.creditRemainingAmount = invoice.remainingAmount;
      if (this.damageHeader.invoiceType == "SALE_RETURN") {
        this.typeDisabled = true;
        this.isItemDiscount = invoice.isItemDiscount;
        this.damageHeader.isItemDiscount = invoice.isItemDiscount;
        this.clearDamageDetail();
        this.damageHeader.damageDetailList = [];
        let itemsList = [];
        if (invoice.saleType == "RETAIL") {
          itemsList = invoice.saleItems;
        } else {
          itemsList = invoice.wholeSaleItems.filter((v)=> !v.isFOC);
        }

        itemsList.forEach((item) => {
          let damageDetail = {
            productId: "",
            productCode: "",
            productName: "",
            factorUnitName: "",
            qty: 0,
            price: 0,
            discountPercent: 0,
            productUnitDTO: {},
            productUnits: [],
            remark: "",
          };

          damageDetail.productId = item.productId;
          damageDetail.productCode = item.productCode;
          damageDetail.productName = item.productName;
          damageDetail.factorUnitName = item.factorUnitName;
          damageDetail.qty = item.qty - item.returnQty;
          if (item.isFOC === false) {
            damageDetail.price = item.unitPrice;
          }
          damageDetail.discountPercent = item.discountPercent;
          damageDetail.productUnitDTO = item.productUnit;
          damageDetail.productUnits.push(item.productUnit);
          damageDetail.qcNo = item.qcNo;
          damageDetail.batchNo = item.batchNo;
          if (item.mfgDateInMilliSeconds) {
            damageDetail.mfgDate = commonService.millisecondToDate(
              item.mfgDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }
          if (item.expDateInMilliSeconds) {
            damageDetail.expDate = commonService.millisecondToDate(
              item.expDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }
          this.damageHeader.damageDetailList.push(damageDetail);
        });
      }
      this.calculate();
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          let isBackStock = this.backInStock ? true : false;
          if (!isBackStock) {
            this.damageHeader.backInStockWarehouseId = "";
            this.damageHeader.backInStockBinId = "";
          }
          //convert to millisecond
          this.damageHeader.issueDateInMilliSeconds =
            commonService.convertToMilliseconds(this.issueDate);
          //check credit invoice type is 'No_Invoice', if credit invoice doesn't exist.
          if (this.damageHeader.creditInvoiceId == "" || this.damageHeader.creditInvoiceId == null) {
            if (this.damageHeader.creditInvoiceType != "NO_INVOICE") {
              this.damageHeader.creditInvoiceType = "NO_INVOICE"
            }
          } else {
            if (this.damageHeader.creditInvoiceType != "WHOLE_SALE") {
              this.damageHeader.creditInvoiceType = "WHOLE_SALE"
            }
          }

          this.damageHeader.damageDetailList.forEach((damageDetail) => {
            if (damageDetail.mfgDate) {
              damageDetail.mfgDateInMilliSeconds =
                commonService.convertToMilliseconds(damageDetail.mfgDate);
            }
            if (damageDetail.expDate) {
              damageDetail.expDateInMilliSeconds =
                commonService.convertToMilliseconds(damageDetail.expDate);
            }
          });

          damageService
            .saveDamage(this.damageHeader)
            .then((res) => {
              if (res) {
                this.goBack();
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.errorMessageBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    // calculateAmount() {
    //   let totalAmount = 0;
    //   let amount = 0;
    //   this.damageHeader.damageDetailList.forEach((item) => {
    //     if (this.isItemDiscount) {
    //       let discount = (item.price * (item.discountPercent / 100)).toFixed(2);
    //       discount = parseFloat(discount);
    //       amount = (item.qty * (item.price - discount)).toFixed(2);
    //     } else {
    //       amount = (item.qty * item.price).toFixed(2);
    //     }
    //     totalAmount += amount;
    //   });
    //   totalAmount = parseFloat(totalAmount);
    //   /*if (this.status == "DRAFT" && this.damageHeader.creditInvoiceId) {
    //     if (totalAmount > this.creditRemainingAmount) {
    //       // Add Item Btn Disable
    //       this.addItemBtnDisabled = true;
    //       this.damageAmtErr =
    //         "*Your Total Damage Amount is about " +
    //         (totalAmount - this.creditRemainingAmount) +
    //         " greater than Credit Remaining Amount. Please adjust the items.";
    //     } else {
    //       this.addItemBtnDisabled = false;
    //       this.damageAmtErr = "";
    //     }
    //   } else {
    //     this.addItemBtnDisabled = false;
    //     this.damageAmtErr = "";
    //   }*/
    // },
    getActiveWarehouse() {
      return warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBinsByWarehouse() {
      let warehouseId = this.damageHeader.backInStockWarehouseId;
      let warehouse = commonService.search(
        "id",
        warehouseId,
        this.warehouseList
      );
      if (warehouse) {
        this.binList = warehouse.binList;
      }
    },
    getWarehouseByShop() {
      this.damageHeader.backInStockBinId = "";
      let shopId = this.damageHeader.shopId;
      let shop = commonService.search(
        "id",
        shopId,
        this.shopList
      );
      if (shop) { 
        this.damageHeader.backInStockWarehouseId = shop.warehouse.id;
        this.getBinsByWarehouse();
      }
    },
    changeInvoiceType() {
      if (this.damageHeader.invoiceType == "SALE_RETURN") {
        this.damageHeader.creditInvoiceId = "";
        this.damageHeader.creditInvoiceType = "NO_INVOICE";
        this.damageHeader.taxAmount = 0;
        this.damageHeader.discountAmount = 0;
        this.damageHeader.promotionAmount = 0;
        this.damageHeader.expenseAmount = 0;
        this.damageHeader.totalAmount = 0;
        this.creditRemainingAmount = 0;
        this.clearDamageDetail();
        this.addItem();
      } else {
        this.typeDisabled = false;
      }
    },
    clearDamageDetail() {
      if (this.firstTimeEdit) {
        this.firstTimeEdit = false;
        let damageDetailList = this.damageHeader.damageDetailList;
        damageDetailList.forEach((item) => {
          if (item) {
            // add delete damage detail id
            if (!this.damageHeader.deleteDamageDetailIds) {
              this.damageHeader.deleteDamageDetailIds = [];
            }
            this.damageHeader.deleteDamageDetailIds.push(item.id);
          }
        });
      }
      this.damageHeader.damageDetailList = [];
      console.log("change1");
    },

    closeErrMsgBox() {
      this.errorMessageBox = false;
      this.responseError = "";
    },

    calculate() {
      let totalAmount = 0;
      let amount = 0;
      this.damageHeader.damageDetailList.forEach((item) => {
        if (this.isItemDiscount) {
          let discount = (item.price * (item.discountPercent / 100)).toFixed(6);
          discount = parseFloat(discount);
          amount = (item.qty * (item.price - discount)).toFixed(6);
        } else {
          amount = (item.qty * item.price).toFixed(6);
        }
        totalAmount += parseFloat(amount);
      });

      totalAmount =
        parseFloat(totalAmount) +
        parseFloat(this.damageHeader.taxAmount) +
        parseFloat(this.damageHeader.expenseAmount) -
        parseFloat(this.damageHeader.discountAmount) -
        parseFloat(this.damageHeader.promotionAmount);

      this.damageHeader.totalAmount = parseFloat(totalAmount.toFixed(6));
    },

    openQCListDialog(damageDetail, index) {
      this.selectedIndex = index;
      this.selectedProductId = damageDetail.productId;
      this.showQCListDialog = true;
    },
    closeQCListDialog(qc) {
      this.showQCListDialog = false;
      if (qc && qc.id) {
        let dmgItem = this.damageHeader.damageDetailList[this.selectedIndex];
        dmgItem.qcNo = qc.qcNo;
        dmgItem.batchNo = qc.batchLotNo;
        if (qc.mfgDateInMilliSeconds) {
          dmgItem.mfgDate = commonService.millisecondToDate(
            qc.mfgDateInMilliSeconds,
            "YYYY-MM-DD"
          );
        }
        if (qc.expDateInMilliSeconds) {
          dmgItem.expDate = commonService.millisecondToDate(
            qc.expDateInMilliSeconds,
            "YYYY-MM-DD"
          );
        }
      }
    },
    clearQCno(damageDetail) {
      damageDetail.qcNo = "";
      damageDetail.batchNo = "";
      damageDetail.mfgDate = "";
      damageDetail.mfgDateInMilliSeconds = "";
      damageDetail.expDate = "";
      damageDetail.expDateInMilliSeconds = "";
    },
  },
};
</script>
